<template>
  <div class="reconsider-basic fd-com-white-bg">
    <MyTitle theTitle="申请复议" />
    <!-- <info-title title-content="复议基本信息" vertical-line="true"/> -->
      <van-cell-group class="fd-com-scroll">
        <van-field
          v-model="formData.cSqfymc"
          required
          clearable
          readonly
          label="选择法院"
          right-icon="arrow"
          placeholder="请选择申请法院"
          input-align="right"
          @click="showCourtPopup = true"
        ></van-field>
        <van-popup
          class="fd-van-popup-fullscreen"
          :overlay="false"
          v-model="showCourtPopup"
          position="bottom"
        >
          <!--                        选择法院 -->
          <ac-select-court
            mklx="3"
            @cancel="showCourtPopup = false"
            @confirm="onConfirmCourt"
          ></ac-select-court>
        </van-popup>
        <van-field
          v-model="formData.cBqah"
          maxlength="50"
          required
          label="案号"
          placeholder="例（2018）京01民初10号"
          input-align="right"
          class="amount-ipt"
        ></van-field>
        <van-field
          v-model="formData.nFysxText"
          required
          readonly
          clickable
          label="复议事项"
          right-icon="arrow"
          placeholder="请选择复议事项"
          input-align="right"
          @click="showPicker = true"
        ></van-field>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_fysx"
            :default-index="0"
            @cancel="showPicker = false"
            @confirm="onConfirmFYSX"
            input-align="right"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.nAjlxText"
          required
          readonly
          label="案件类型"
          right-icon="arrow"
          placeholder="请选择案件类型"
          @click="showPickerAjlx = true"
          input-align="right"
        ></van-field>
        <van-popup v-model="showPickerAjlx" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_ajlx"
            :default-index="0"
            @cancel="showPickerAjlx = false"
            @confirm="onConfirmAjlx"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.cTjrlxText"
          required
          readonly
          label="提交人身份"
          right-icon="arrow"
          placeholder="请选择提交人身份"
          @click="showPickeSQR = true"
          input-align="right"
        ></van-field>
        <van-popup v-model="showPickeSQR" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_118000"
            :default-index="0"
            @cancel="showPickeSQR = false"
            @confirm="onConfirmSQR"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.dtSqrq"
          required
          readonly
          label="创建申请日期"
          placeholder="选择日期"
          input-align="right"
        ></van-field>
        <van-field
          class="van-field--column amount-ipt"
          maxlength="200"
          required
          v-model="formData.cFyky"
          type="textarea"
          label="复议理由"
          placeholder="请输入复议理由"
        ></van-field>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
            type="info"
            round
            @click="applyReconsider">
            申请复议
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../components/common/myTitle";
// 选择法院组件
import acSelectCourt from "@/components/app/select-court/index.vue";
// 基础信息
import basic from "@/views/applyReconsider/mixins/basic";
import { typeFyAjlx } from "@/filters";
export default {
  // 混入
  mixins: [basic],
  data() {
    return {
      fyid: this.$route.query.id,
      //基本信息
      formData: {
        cId: "",
        // 申请法院code
        nSqfy: "",
        // 申请法院名称
        cSqfymc: "",
        // 保全案号
        cBqah: "",
        // 复议事项
        nFysx: "",
        // 复议事项文字
        nFysxText: "",
        // 案件类型
        nAjlx: 12,
        nAjlxText: "",
        // 提交人身份
        cTjrlx: 1,
        cTjrlxText: "申请人",
        //申请日期
        dtSqrq: this.getCurrentData(),
        // 复议理由
        cFyky: "",
      },
      //是否展示日期
      showCalendar: false,
    };
  },
  components: {
    MyTitle,
    acSelectCourt,
  },
  created() {
    // 初始化方法
    this.init();
  },
  methods: {
    /**
     * 初始化方法
     * */
    init() {
      // 如果复议id存在则请求基本的复议id数据
      if (this.fyid) {
        this.getBasic(this.fyid);
      } else {
        // 案件类型文本
        this.formData.nAjlxText = typeFyAjlx(this.formData.nAjlx);
      }
    },

    /**
     * 点击确定
     * */
    applyReconsider() {
      // 校验基础数据
      this.validateBasicData(this.formData)
        .then(() => {
          this.$axios
            .post("ssbq/api/fy/xcx/sqfy", this.formData)
            .then((res) => {
              if (res.code === 200) {
                // 跳转到申请复议页面
                this.$router.push("/applyReconsider?id=" + res.data);
              }
            });
        })
        .catch(() => {
          console.log("请完整填写表单数据");
        });
    },
  },
};
</script>
